<template>
  <component :is="pageComponent" />
</template>

<script>
import SocialNetworksLegacy from './SocialNetworksLegacy.vue'
import SocialNetworksRefonte from './SocialNetworksRefonte.vue'
import { isSocialNetworksRefonteEnabled } from '@/helpers/socialNetworksRefonte'

export default {
  name: 'social-networks',
  computed: {
    pageComponent () {
      return isSocialNetworksRefonteEnabled()
        ? SocialNetworksRefonte
        : SocialNetworksLegacy
    }
  }
}
</script>
